<template>
  <div class="uk-grid-medium uk-child-width-expand@s uk-text-center section3" uk-grid id="special-packages">
    <div class="uk-width-1-1@l uk-width-1-1@m  uk-width-1-1@s">
      <h1 class="uk-text-center uk-text-middle AppTitle Title">{{'features'|translate}}</h1>
    </div>
    <div class="uk-width-1-1@l uk-width-1-1@m  uk-width-1-1@s">
      <p class="description">{{description}}</p>
    </div>
    <div class="uk-grid-small uk-child-width-1-2@m uk-text-center" uk-grid uk-height-match="target: > div > .uk-card">
      <div v-for="(item, index) in features" :key="index">
        <div class="uk-card section2 uk-card-default uk-card-body">
          <h4><span :uk-icon="item.icon"></span> {{item.feature}}</h4>
          <div class="uk-child-width-1-1@l uk-text-muted uk-text-center">
            {{item.description}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertySectionSix',
  props: ['description', 'features']
}
</script>

<style scoped>
  .section3 {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .Title {
    font-family: 'Kaushan Script', cursive !important;
  }

  .section2 {
    padding-top: 20px;
  }
</style>
